import { createAsyncAtom } from '../lib';
import rpcProviderAtom from './rpcProviderAtom';

const latestBlockAtom = createAsyncAtom(
  async get => {
    const provider = await get(rpcProviderAtom);

    const latestBlock = await provider.getBlockLatestAccepted();

    return latestBlock.block_number;
  },
  undefined,
  ['user-refresh'],
);
export default latestBlockAtom;
